import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ArrowBack } from '@mui/icons-material';
import { Alert, Box, Button, LinearProgress, Paper } from '@mui/material';

import { getListingPath } from 'lib/nfcCardScreens';

import NfcCardSummary from 'components/NfcCardSummary';

type Props = {
	card: NfcCard | null;
	loading: boolean;
};

/**
 * The top of every card screen: which card it is and the way back to the listing, to the
 * same filters and page it was opened from.
 */
export default function NfcCardHeader({ card, loading }: Props) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<Paper variant="outlined" sx={{ padding: 2, marginBottom: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
			<Box>
				<Button startIcon={<ArrowBack />} onClick={() => navigate(getListingPath(location.state))} sx={{ ml: -1 }}>
					{t('nfc:backToList')}
				</Button>
			</Box>

			{loading && <LinearProgress />}

			{!loading && !card && <Alert severity="error">{t('nfc:cardFailed')}</Alert>}

			{!!card && <NfcCardSummary card={card} large />}
		</Paper>
	);
}
